import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";

import { headingFontFamily } from "../heading-font";
import { FaqSchema } from "~landing/seo/faq-schema";

import { Faq } from "./faq";

const faqs = [
	{
		id: "FAQ-1",
		question: "Can I change my plan or add-ons at any time?",
		answer:
			"Yes. You can upgrade, downgrade, or add seats and storage at any time from your account settings. Changes take effect immediately and are prorated to your billing cycle.",
	},
	{
		id: "FAQ-2",
		question: "What is the difference between an editor and an admin?",
		answer:
			"Editors can create and edit maps and upload data. Admins have full control over the account, including managing users and account settings. Every plan includes one super admin seat with total control.",
	},
	{
		id: "FAQ-3",
		question: "What happens to my maps if I downgrade or cancel?",
		answer:
			"Your maps and data are never deleted automatically. If your current usage exceeds the limits of your new plan, you'll need to remove the excess before the downgrade can complete. We'll show you exactly what needs to be resolved before you confirm the change.",
	},
	{
		id: "FAQ-4",
		question: "Do viewers need a paid seat?",
		answer:
			"No. You can invite unlimited viewers to your maps for free. Viewer seats are included on all paid plans — you only pay for editors and admins.",
	},
	{
		id: "FAQ-5",
		question: "Are there discounts for longer commitments?",
		answer:
			"Yes. Annual billing saves around 20% compared to monthly. For multiyear subscriptions, we offer 30% off — contact us to arrange this.",
	},
];

export function Faqs() {
	return (
		<Box sx={{ py: "120px" }}>
			<FaqSchema faqs={faqs} />
			<Container maxWidth="lg">
				<Grid
					container
					spacing={3}>
					<Grid
						size={{
							md: 6,
							xs: 12,
						}}>
						<Stack spacing={2}>
							<Typography
								sx={{ fontFamily: headingFontFamily }}
								variant="h3">
								No surprises
							</Typography>
							<Typography
								color="text.secondary"
								variant="subtitle2"
								sx={{ fontFamily: headingFontFamily }}>
								Straight answers to the questions we hear most.
							</Typography>
						</Stack>
					</Grid>
					<Grid
						size={{
							md: 6,
							xs: 12,
						}}>
						<Stack spacing={3}>
							{faqs.map((faq) => (
								<Faq
									key={faq.id}
									{...faq}
								/>
							))}
						</Stack>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
}
